import * as React from 'react';
import S from 's-js';
import * as L from 'leaflet';
import { SuperCriticalComponent, SuperCriticalReference } from 'lib/supercritical';
import escapeHtml from 'lib/escapeHtml';

import { Location } from 'data/models/Location';
import { parseZoneCoordinates, LatLong, CircleCoords, PolygonCoords } from 'data/models/ZoneCoordinates';
import { drawLocation, MAP_FILL_COLOR } from 'portcall/maps/maptools';
import { Map } from './map';
import 'leaflet-providers';

interface MapViewProps { model : Map }

export class MapView extends SuperCriticalComponent<MapViewProps> {
    ref : (el : HTMLDivElement | null) => void;

    constructor(props : MapViewProps) {
        super(props);
        this.ref = SuperCriticalReference(this, loadMap);
    }

    srender({model} : MapViewProps) {
        return (
            <div className="homepage-map">
                <div className="map" ref={this.ref}></div>
            </div>
        );
    }
}

function loadMap({ model: m } : { model : Map }, el : HTMLDivElement) {
    const map = L.map(el, { attributionControl: true });
    S.cleanup(() => map.remove());

    L.tileLayer((L.TileLayer as any).Provider.providers.Esri.url, (L.TileLayer as any).Provider.providers.Esri.variants.WorldImagery.options).addTo(map);

    S(() => m.Locations().forEach(loc => {
        const coords = parseZoneCoordinates(loc.ZoneCoordinates(), loc.ZoneType()),
            center = drawLocation(map, coords);

        if (center) {
            const label = drawLocationLabel(loc, center);
            map.addLayer(label);
            S.cleanup(() => map.removeLayer(label));
        }
    }));

    S(() => {
        // TH 12/19/2016 -- To avoid some UX jumpiness, don't call setView until we think we have map coords populated.
        if (m.Settings.Latitude() || m.Settings.Longitude() || m.Settings.Zoom()) {
            map.setView([m.Settings.Latitude(), m.Settings.Longitude()], m.Settings.Zoom());
        }
    });

    // b/c the map is not displayed when initially draw, Leaflet draws it with an incorrect size
    // so we tell it to redraw it once it appears
    S(() => {
        if (m.Shown()) window.requestAnimationFrame(() => map.invalidateSize(false));
    });
}

function drawLocationLabel(loc : Location, pt : L.LatLng) {
    const icon = L.divIcon({
        className: 'zone-label',
        iconSize: L.point(40, 20),
        iconAnchor: L.point(20, 20),
        popupAnchor: L.point(0, -20),
        html: '<div class="content-label">' + escapeHtml(loc.Name()) + '</div>'
    });

    return L.marker(pt, { icon: icon });
}


// WEBPACK FOOTER //
// ./apps/portcall/homepage/mapview.tsx